const SEARCH_TEXT_FIELD = 'testTitleSearchText';
const SEARCH_KEYWORDS_FIELD = 'testTitleSearchKeywords';
const MAX_SEARCH_KEYWORDS = 160;

export const POST_TEST_SEARCH_FIELDS = {
    text: SEARCH_TEXT_FIELD,
    keywords: SEARCH_KEYWORDS_FIELD,
};

export const normalizePostTestSearchTerm = (value) => {
    return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};

const getPostTestTitleValues = (postTest) => {
    const titleVariations = Array.isArray(postTest?.titles) ? postTest.titles : [];

    return [
        postTest?.testTitle,
        ...titleVariations,
    ].filter((value) => typeof value === 'string' && value.trim());
};

export const getPostTestSearchText = (postTest) => {
    return normalizePostTestSearchTerm(getPostTestTitleValues(postTest).join(' '));
};

export const buildPostTestSearchKeywords = (postTest) => {
    const words = getPostTestSearchText(postTest).split(' ').filter(Boolean);
    const keywords = new Set();

    words.forEach((word) => {
        for (let index = 1; index <= word.length; index += 1) {
            keywords.add(word.slice(0, index));
        }
    });

    return Array.from(keywords).slice(0, MAX_SEARCH_KEYWORDS);
};

export const withPostTestSearchFields = (postTest) => ({
    ...postTest,
    [SEARCH_TEXT_FIELD]: getPostTestSearchText(postTest),
    [SEARCH_KEYWORDS_FIELD]: buildPostTestSearchKeywords(postTest),
});

export const getPostTestSearchToken = (searchTerm) => {
    return normalizePostTestSearchTerm(searchTerm).split(' ')[0] || '';
};

export const postTestMatchesSearch = (postTest, searchTerm) => {
    const normalizedSearch = normalizePostTestSearchTerm(searchTerm);

    if (!normalizedSearch) {
        return true;
    }

    const searchText = postTest?.[SEARCH_TEXT_FIELD] || getPostTestSearchText(postTest);
    return searchText.includes(normalizedSearch);
};
